module.exports = __webpack_public_path__ + "static/media/webdesire.9b3a3053.png";